exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contactForm {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  /* align-items: flex-start; */\n  -webkit-justify-content: left;\n          justify-content: left;\n  justify-items: left;\n  \n}\n.submitButton {\n  width: 25%;\n  /* background-color: blue; */\n  color: white;\n  float: right;\n  margin-left: 70%;\n  cursor: pointer;\n  \n}\n", ""]);

// exports
